import { type ShortcutModifier, ShortcutModifierKeys } from './shortcuts-types';

/**
 * Sorts the given array of modifier keys, so that they follow a consistent order.
 *
 * This is useful for comparing two arrays of modifiers, e.g. when comparing
 * Shift-Control to Control-Shift.
 *
 * @param modifiers The modifiers to sort in-place.
 */
export function sortModifiers(modifiers: ShortcutModifier[]) {
  modifiers.sort(
    (a, b) => ShortcutModifierKeys.indexOf(a) - ShortcutModifierKeys.indexOf(b),
  );

  return modifiers;
}
